module.exports = __webpack_public_path__ + "img/information.572b2dd3.svg";